import { TRADESMANLOGIN, TRADESMANLOGOUT } from '.././mutation_types'

// localStorage 保存数据时间更久，不会因为关闭标签而丢失

const state = {
  tradesman_id: localStorage.getItem('tradesman_id') || 0,
  tradesman_name: localStorage.getItem('tradesman_name') || '未登录',
  tradesmantoken: localStorage.getItem('tradesmantoken') || ''
}

const getters = {
  tradesman_id: state => {
    return state.tradesman_id
  },
  tradesman_name: state => {
    return state.tradesman_name
  },
  tradesmantoken: state => {
    return state.tradesmantoken
  }
}

const mutations = {
  [TRADESMANLOGIN] (state, data) {
    console.log(data)
    if (data != undefined) {
      localStorage.setItem('tradesman_id', data.uuid) // 设置localStorage
      localStorage.setItem('tradesman_name', data.name)
      localStorage.setItem('tradesmantoken', data.token)
      state.tradesman_id = data.uuid
      state.tradesman_name = data.name
      state.tradesmantoken = data.token
    } else {
      localStorage.setItem('tradesman_id', "") // 设置localStorage
      localStorage.setItem('tradesman_name', "")
      localStorage.setItem('tradesmantoken', "")
      state.tradesman_id = ""
      state.tradesman_name = ""
      state.tradesmantoken = ""
    }

  },
  [TRADESMANLOGOUT] (state) {
    localStorage.removeItem('tradesman_id') // 移除localStorage
    localStorage.removeItem('tradesman_name')
    localStorage.removeItem('tradesmantoken')
    state.tradesman_id = ""
    state.tradesman_name = ''
    state.tradesmantoken = ''
  }
}

export default {
  state,
  mutations,
  getters
}
